import React from 'react';
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import moment from "moment";

const Warehouse = ({index, warehouse, deleteWarehouse}) => {
  function displayWorkingHours(openTime, closeTime) {
    if (openTime && closeTime) {
      const openHours = openTime.substr(0, 2);
      const closeHours = closeTime.substr(0, 2);
      const openMinutes = openTime.substr(openTime.indexOf(':') + 1, 2);
      const closeMinutes = closeTime.substr(closeTime.indexOf(':') + 1, 2);
      const date = moment();

      return `${date.hours(openHours).minutes(openMinutes).format('hh:mm A')} - ${date.hours(closeHours).minutes(closeMinutes).format('hh:mm A')}`;
    }

    return 'Opened Overnight';
  }

  return (
      <tr>
        <td>{index + 1}</td>
        <td>{warehouse.name}</td>
        <td>{displayWorkingHours(warehouse.open_date, warehouse.close_date)}</td>
        <td>{warehouse.docks_count}</td>
        <td>
          <Link to={`/warehouses/${warehouse.id}`} className="view-staff"><i className="icon-eye"/></Link>
          <Link to={`/warehouses/${warehouse.id}/edit`} className="edit-staff"><i className="icon-pencil"/></Link>
          <button onClick={() => deleteWarehouse(warehouse.id)} type="button" className="delete-staff"
                  data-target=".delete-staff-modal"
                  data-toggle="modal"><i className="icon-delete"/></button>
        </td>
      </tr>
  );
};

Warehouse.propTypes = {
  warehouse: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  deleteWarehouse: PropTypes.func.isRequired
};

export default Warehouse;



// WEBPACK FOOTER //
// ./src/components/WarehousesList/Warehouse.jsx